import { Page } from '@app/components/page/Page';
import { useStation } from '@app/core/stations/hooks/useStation';
import { SocialExportBreadcrumbs } from '@app/modules/social-export/components/breadcrumbs/SocialExportBreadcrumbs';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { ReactNode } from 'react';

interface Props {
  platform: SocialPlatform;
  stationId: string;
  children: ReactNode;
}

export function BasePlatformSettingsPage({ platform, stationId, children }: Props) {
  const station = useStation(stationId);

  return (
    <Page>
      <Page.Header
        icon={platform.Icon()}
        title={`Configurar ${station.name}`}
        breadcrumbs={<SocialExportBreadcrumbs platform={platform} />}
      />
      <Page.Content>{children}</Page.Content>
    </Page>
  );
}
